// extracted by mini-css-extract-plugin
export default {"marketing-section":"_1pu2u630ReAfwGRCT11ARC","img-md":"_2bV0Oi_yo-7afAvjIacBlr","margin-top-sm":"zIAphTSVsU5tlmdZMkRgI"};